import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login';
import Competition from './competition';
import './App.css';

function App() {
  const [userData, setUserData] = useState(null);

  // Configuration for Competition System
  const competitionConfig = {
    defaultMeetingId: 'PowerWisdom-ห้องสอบ1',
    defaultUserName: userData?.username || 'Guest'
  };

  const handleLoginSuccess = (userData) => {
    setUserData(userData);
  };

  return (
    <div className="App">
      <Routes>
        <Route 
          path="/" 
          element={
            userData ? 
            <Navigate to="/exercies" replace /> : 
            <Login onLoginSuccess={handleLoginSuccess} />
          } 
        />
        <Route 
          path="/exercies" 
          element={
            userData ? 
            <Competition 
              config={competitionConfig}
              onReturn={() => {
                setUserData(null);
              }}
            /> : 
            <Navigate to="/" replace />
          } 
        />
      </Routes>
    </div>
  );
}

export default App;